<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black2">
      <img
        src="/img/myreward/img-bg.webp"
        width="1360px"
        height="400px"
        style="position: absolute; left: calc(50% - 680px)"
      />
      <div
        class="bg_bonus-area"
        v-bind:style="{ height: getTotalHeight() }"
      ></div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      >
        <div class="MYREWARD">MY REWARD</div>
      </div>
      <div
        class="bg_staking_total"
        style="position: absolute; top: 450px; left: calc(50% - 640px)"
      >
        <div
          class="bg_card_reward_bonus"
          style="position: absolute; left: 50px; top: 50px"
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              width: 1180px;
              height: 60px;
              border: solid 0 #000;
              background-color: #3920d7;
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              letter-spacing: -0.2px;
              text-align: left;
              color: #ffffff;
              padding-left: 30px;
              padding-top: 14px;
            "
          >
            Total Reward
            <div
              v-if="isAdmin == true"
              style="
                float: right;
                margin-right: 30px;
                font-size: 13px;
                padding-top: 10px;
                cursor: pointer;
              "
              @click="goAdmin()"
            >
              ADMIN
            </div>
          </div>
          <div
            style="
              position: absolute;
              left: 30px;
              top: 90px;
              width: 120px;
              padding-left: 18px;
              padding-top: 17px;
              height: 120px;
              border-radius: 12px;
              border: solid 0 #000;
              background-color: #edf0f6;
            "
          >
            <img src="/img/myreward/icon-reward-loka.png" />
          </div>
          <div
            style="
              position: absolute;
              left: 190px;
              top: 105px;
              width: 780px;
              height: 90px;
            "
          >
            <div style="width: 100%; height: 40px">
              <div
                style="
                  width: 260px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Total
              </div>
              <div
                style="
                  width: 260px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Locked
              </div>
              <div
                style="
                  width: 260px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Claimed
              </div>
            </div>
            <div style="width: 100%; height: 40px">
              <div
                style="
                  width: 260px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: bold;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ total.total.toFixed(2) | comma }}
                <span style="color: #a5aaba; margin-left: 5px; font-weight: 500"
                  >LOKA</span
                >
              </div>
              <div
                style="
                  width: 260px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: bold;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ total.locked.toFixed(2) | comma }}
                <span style="color: #a5aaba; margin-left: 5px; font-weight: 500"
                  >LOKA</span
                >
              </div>
              <div
                style="
                  width: 260px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: bold;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ total.claimed.toFixed(2) | comma }}
                <span style="color: #a5aaba; margin-left: 5px; font-weight: 500"
                  >LOKA</span
                >
              </div>
            </div>
          </div>
          <div
            v-if="total.claimable > 0"
            style="
              position: absolute;
              top: 90px;
              right: 30px;
              width: 180px;
              height: 120px;
              padding-top: 40px;
              border-radius: 8px;
              border: solid 0 #000;
              background-color: #3920d7;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              cursor: pointer;
            "
            @click="onClickClaimAll()"
          >
            CLAIM ALL
            <div
              style="
                font-family: Poppins;
                font-size: 13px;
                text-align: center;
                color: #2fd;
              "
            >
              {{ total.claimable.toFixed(2) | comma }} LOKA
            </div>
          </div>
          <div
            v-else
            style="
              position: absolute;
              top: 90px;
              right: 30px;
              width: 180px;
              height: 120px;
              padding-top: 40px;
              border-radius: 8px;
              border: solid 0 #000;
              background-color: #d6dce6;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
            "
          >
            CLAIM ALL
            <div
              style="
                font-family: Poppins;
                font-size: 13px;
                text-align: center;
                color: #fff;
              "
            >
              {{ total.claimable.toFixed(2) | comma }} LOKA
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="vestings.length > 0"
        class="bg_reward_main"
        style="position: absolute; top: 790px; left: calc(50% - 640px)"
      >
        <div
          v-for="(vesting, idx) in vestings"
          :key="idx"
          class="bg_card_reward_bonus"
          style="position: absolute; left: 50px; top: 50px"
          v-bind:style="{ top: `${50 + 290 * idx}px` }"
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              width: 1180px;
              height: 60px;
              border: solid 0 #000;
              border-radius: 12px;
              background-color: #edf0f6;
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              letter-spacing: -0.2px;
              text-align: left;
              color: #202431;
              padding-left: 30px;
              padding-top: 14px;
            "
          >
            {{ vesting.title }}
          </div>
          <div
            style="
              position: absolute;
              left: 30px;
              top: 90px;
              width: 120px;
              padding-left: 9px;
              padding-top: 14px;
              height: 120px;
              border-radius: 12px;
              border: solid 0 #000;
              background-color: #edf0f6;
            "
          >
            <img src="/img/myreward/icon-bonus.png" />
          </div>
          <div
            style="
              position: absolute;
              left: 190px;
              top: 95px;
              width: 280px;
              height: 90px;
            "
          >
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Total
              </div>
              <div
                style="
                  width: 160px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ vesting.total.toFixed(2) | comma }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: right;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
            </div>
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Locked
              </div>
              <div
                style="
                  width: 160px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ (vesting.total - vesting.claimed).toFixed(2) | comma }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: right;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
            </div>
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Claimed
              </div>
              <div
                style="
                  width: 160px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ vesting.claimed.toFixed(2) | comma }}
              </div>
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: right;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
            </div>
          </div>
          <div
            style="
              position: absolute;
              left: 519px;
              top: 90px;
              width: 1px;
              height: 120px;
              border: solid 0 #000;
              background-color: #d9ddef;
            "
          ></div>
          <div
            style="
              position: absolute;
              left: 570px;
              top: 95px;
              width: 324px;
              height: 120px;
            "
          >
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Start
              </div>
              <div
                style="
                  width: 264px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ vesting.started | date }}
              </div>
            </div>
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Cliff
              </div>
              <div
                v-if="vesting.cliff == null"
                style="
                  width: 264px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                -
              </div>
              <div
                v-else
                style="
                  width: 264px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ vesting.cliff | date }}
              </div>
            </div>
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Frequency
              </div>
              <div
                style="
                  width: 264px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ Math.floor(vesting.frequency / (24 * 60 * 60)) }} day
              </div>
            </div>
            <div style="width: 100%; height: 28px">
              <div
                style="
                  width: 60px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Counts
              </div>
              <div
                style="
                  width: 264px;
                  height: 100%;
                  float: left;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: right;
                  color: #202431;
                "
              >
                {{ vesting.count | comma }}
              </div>
            </div>
          </div>
          <div
            v-if="vesting.claimable > 0"
            style="
              position: absolute;
              top: 90px;
              right: 30px;
              width: 180px;
              height: 120px;
              padding-top: 40px;
              border-radius: 8px;
              border: solid 0 #000;
              background-color: #3920d7;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              cursor: pointer;
            "
            @click="onClickClaim(vesting._id)"
          >
            CLAIM
            <div
              style="
                font-family: Poppins;
                font-size: 13px;
                text-align: center;
                color: #2fd;
              "
            >
              {{ vesting.claimable.toFixed(2) | comma }} LOKA
            </div>
          </div>
          <div
            v-else
            style="
              position: absolute;
              top: 90px;
              right: 30px;
              width: 180px;
              height: 120px;
              padding-top: 40px;
              border-radius: 8px;
              border: solid 0 #000;
              background-color: #d6dce6;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #fff;
            "
          >
            CLAIM
            <div
              style="
                font-family: Poppins;
                font-size: 11px;
                text-align: center;
                color: #3920d7;
              "
            >
              NEXT {{ vesting.next | date }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="
        modals.popup_wait_claim_tx == true ||
        modals.popup_done_claim_tx == true ||
        modals.popup_admin == true
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="modals.popup_wait_claim_tx"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Claim processing step 1
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 160px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for claim loka...<br /><br />
        It may take up to 2~5 minutes depending on the Ethereum network.<br /><br />
        After the transaction is complete, move on to the next step.
      </div>
      <!-- <div
      id="loading-image"
      style="position: absolute; left: calc(50% - 40px); bottom: 150px"
    ></div> -->
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.popup_done_claim_tx"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Claim processing step 2
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 160px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for claim loka...<br /><br />
        It may take up to 2~5 minutes depending on the Ethereum network.<br /><br />
        After claim, you can see the loka in your wallet.
      </div>
      <!-- <div
      id="loading-image"
      style="position: absolute; left: calc(50% - 40px); bottom: 150px"
    ></div> -->
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.popup_admin"
      style="
        position: fixed;
        top: calc((100% - 740px) / 2);
        left: calc((100% - 1140px) / 2);
        text-align: center;
        width: 1140px;
        height: 740px;
        border-radius: 20px;
        box-shadow: 0px -10px 10px 0 rgba(0, 0, 0, 0.1);
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        ADMIN
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        style="
          position: absolute;
          left: calc(50% - 570px);
          top: 80px;
          width: 1140px;
          height: 120px;
          margin-top: 40px;
          padding-left: 20px;
        "
      >
        <div style="float: left; width: 150px">Address</div>
        <div style="float: left; width: 100px">Pool</div>
        <div style="float: left; width: 150px">Title</div>
        <div style="float: left; width: 100px">Total</div>
        <div style="float: left; width: 150px">Start</div>
        <div style="float: left; width: 150px">Cliff</div>
        <div style="float: left; width: 100px">Frequency</div>
        <div style="float: left; width: 100px">Count</div>
      </div>
      <div
        style="
          position: absolute;
          left: calc(50% - 570px);
          top: 120px;
          width: 1140px;
          height: 120px;
          margin-top: 40px;
          padding-left: 20px;
        "
      >
        <div style="float: left; width: 150px">
          <input
            type="text"
            v-model="newVesting.address"
            style="
              width: 130px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 100px">
          <select
            v-model="newVesting.poolType"
            style="
              width: 100%;
              text-align: center;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 2.46;
              letter-spacing: -0.33px;
              text-align: center;
              color: #444;
            "
          >
            <option value="0">Game</option>
            <option value="1">Eco</option>
            <option value="2">Reserve</option>
            <option value="3">Advisor</option>
            <option value="4">Eco[WLoka]</option>
          </select>
        </div>
        <div style="float: left; width: 150px">
          <input
            type="text"
            v-model="newVesting.title"
            style="
              width: 130px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 100px">
          <input
            type="text"
            v-model="newVesting.total"
            style="
              width: 80px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 150px">
          <input
            type="text"
            v-model="newVesting.started"
            style="
              width: 130px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 150px">
          <input
            type="text"
            v-model="newVesting.cliff"
            style="
              width: 130px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 100px">
          <input
            type="text"
            v-model="newVesting.frequency"
            style="
              width: 80px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 100px">
          <input
            type="text"
            v-model="newVesting.count"
            style="
              width: 80px;
              height: 25px;
              padding-left: 10px;
              padding-right: 10px;
              border-radius: 8px;
              border: solid 1px #dfe5ef;
              text-align: left;
              background-color: #fff;
              margin-left: 10px;
            "
          />
        </div>
        <div style="float: left; width: 100px">
          <div
            @click="registerVesting()"
            style="
              width: 80px;
              margin-top: 0px;
              margin-left: 10px;
              height: 25px;
              padding-top: 4px;
              border-radius: 8px;
              border: solid 0 #000;
              background-color: #3920d7;
              font-family: Poppins;
              font-size: 12px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              cursor: pointer;
            "
          >
            ADD
          </div>
        </div>
      </div>
      <div
        style="position: absolute; left: 0px; top: 100px;"
      >
        <div style="position: absolute; top: 100px; left: 0px; width: 1140px; height: 550px; overflow:scroll; ">
          <div v-for="(vesting, adminIdx) in admin.vestings" :key="adminIdx"
            style="
              position: absolute;
              left: calc(50% - 570px);
              width: 1140px;
              height: 40px;
              margin-top: 40px;
              padding-left: 20px;
            "
            v-bind:style="{ top: `${40 * adminIdx}px` }"
          >
            <div style="float: left; width: 150px">
              <input
                readonly
                type="text"
                v-model="vesting.publicKey"
                style="
                  width: 130px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 100px">
              <select
              readonly
                v-model="vesting.poolType"
                style="
                  width: 100%;
                  text-align: center;
                  font-size: 16px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 2.46;
                  letter-spacing: -0.33px;
                  text-align: center;
                  color: #444;
                "
              >
                <option value="0">Game</option>
                <option value="1">Eco</option>
                <option value="2">Reserve</option>
                <option value="3">Advisor</option>
                <option value="4">Eco[WLoka]</option>
              </select>
            </div>
            <div style="float: left; width: 150px">
              <input
              readonly
                type="text"
                v-model="vesting.title"
                style="
                  width: 130px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 100px">
              <input
              readonly
                type="text"
                v-model="vesting.total"
                style="
                  width: 80px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 150px">
              <input
              readonly
                type="text"
                v-bind:value="showDate(vesting.started)"
                style="
                  width: 130px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 150px">
              <input
              readonly
                type="text"
                v-bind:value="showDate(vesting.cliff)"
                style="
                  width: 130px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 100px">
              <input
              readonly
                type="text"
                v-model="vesting.frequency"
                style="
                  width: 80px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 100px">
              <input
              readonly
                type="text"
                v-model="vesting.count"
                style="
                  width: 80px;
                  height: 25px;
                  padding-left: 10px;
                  padding-right: 10px;
                  border-radius: 8px;
                  border: solid 1px #dfe5ef;
                  text-align: left;
                  background-color: #fff;
                  margin-left: 10px;
                "
              />
            </div>
            <div style="float: left; width: 100px">
              <div
                @click="stopVesting(vesting._id)"
                style="
                  width: 80px;
                  margin-top: 0px;
                  margin-left: 10px;
                  height: 25px;
                  padding-top: 4px;
                  border-radius: 8px;
                  border: solid 0 #000;
                  background-color: #ff0000;
                  font-family: Poppins;
                  font-size: 12px;
                  font-weight: 600;
                  text-align: center;
                  color: #fff;
                  cursor: pointer;
                "
              >
                STOP
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>
<script>
import { Parallax } from "@/components";
import moment from "moment";
import config from "../config.js";
import axios from "axios";
import {
  hatchDrago,
  rehatchDrago,
  sendTransaction,
  getNetwork,
  connectWallet,
} from "../utils/wallet";

export default {
  name: "myDrago",
  bodyClass: "myDrago-page",
  components: {
    Parallax,
  },
  created() {},

  mounted: async function () {
    await connectWallet(this.$store);
    this.getVestingDashboard();
  },
  beforeDestroy() {},
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async closeAllPopup() {
      this.modals.popup_admin = false;
      this.modals.popup_wait_claim_tx = false;
      this.modals.popup_done_claim_tx = false;
      await this.getVestingDashboard();
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();

      this.modals[modal] = true;
    },
    getTop(index) {
      return Math.floor(index / 4) * 413 + "px";
    },
    getLeft(index) {
      return (index % 4) * 280 + "px";
    },
    getListHeight() {
      let num = this.myEggs.length + this.myDragos.length;
      let row = Math.floor((num - 1) / 4) + 1;
      if (row <= 2) {
        return "806px";
      }
      return 393 * row + 20 * (row - 1) + "px";
    },
    getTotalHeight() {
      return "2400px";
    },
    async startHatching(eggId, txHash) {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.nft_url}/drago/hatch/start`, {
        address: address,
        tokenId: eggId,
        txHash: txHash,
      });
      if (ret.data.result) {
        await this.getDragoInventory();
      }
    },
    async goAdmin() {
      this.closeAllPopup();
      await this.getVestingList();
      this.openModal("popup_admin");
    },
    async onClickClaimAll() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      let chainId = await getNetwork();
      if(chainId!=1&&chainId!=137)
        return alert("Wrong network. Please connect to Ethereum or Polygon network.");
      var ret = await axios.post(`${config.api.game_url}/vesting/claim/all`, {
        publicKey: address,
        chainId: chainId
      });
      console.log(ret.data);
      if (ret.data.result) {
        let param = ret.data.txData;
        let claimable = ret.data.claimable;
        if (typeof param == "string") param = JSON.parse(param);
        param.from = address;
        if (param.chainId != (await getNetwork())) return alert("Wrong network. Please connect to Ethereum or Polygon network.");
        let self = this;
        sendTransaction(param, address)
          .on("transactionHash", async (txHash) => {
            console.log("transactionHash");
            console.log(txHash);
            self.tx_id = txHash;
            self.claimable = claimable;
            self.closeAllPopup();
            self.openModal("popup_wait_claim_tx");
          })
          .on("receipt", async (receipt) => {
            console.log("receipt");
            console.log(receipt);
            self.closeAllPopup();
            self.openModal("popup_done_claim_tx");
          })
          .on("error", (error) => {
            console.log("error");
            console.log(error);
            alert(error);
          });
      }
    },
    async onClickClaim(vestingId) {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      let chainId = await getNetwork();
      if(chainId!=1&&chainId!=137)
        return alert("Wrong network. Please connect to Ethereum or Polygon network.");
      var ret = await axios.post(`${config.api.game_url}/vesting/claim`, {
        publicKey: address,
        vestingId: vestingId,
        chainId: chainId
      });
      console.log(ret.data);
      if (ret.data.result) {
        let param = ret.data.txData;
        let claimable = ret.data.claimable;
        if (typeof param == "string") param = JSON.parse(param);
        param.from = address;
        if (param.chainId != (await getNetwork())) return alert("Wrong network. Please connect to Ethereum or Polygon network.");
        let self = this;
        sendTransaction(param, address)
          .on("transactionHash", async (txHash) => {
            console.log("transactionHash");
            console.log(txHash);
            self.tx_id = txHash;
            self.claimable = claimable;
            self.closeAllPopup();
            self.openModal("popup_wait_claim_tx");
          })
          .on("receipt", async (receipt) => {
            console.log("receipt");
            console.log(receipt);
            self.closeAllPopup();
            self.openModal("popup_done_claim_tx");
          })
          .on("error", (error) => {
            console.log("error");
            console.log(error);
            alert(error);
          });
      }
    },
    async getVestingList() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/vesting/list`, {
        publicKey: address,
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.admin.vestings = ret.data.vestings;
      }
    },
    async registerVesting() {
      if (!window.confirm("Are you sure?")) {
        return;
      }

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/vesting/register`, {
        publicKey: address,
        address: this.newVesting.address,
        title: this.newVesting.title,
        poolType: this.newVesting.poolType,
        total: this.newVesting.total,
        frequency: this.newVesting.frequency,
        count: this.newVesting.count,
        cliff: this.newVesting.cliff,
        started: this.newVesting.started,
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.newVesting = {
          poolType: 0,
          address: "",
          total: 0,
          title: "",
          started: "",
          cliff: "",
          frequency: 0,
          count: 0,
        };
        await this.getVestingList();
      } else {
        alert(ret.data.err);
      }
    },
    async stopVesting(vestingId) {
      if (!window.confirm("Are you sure?")) {
        return;
      }

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/vesting/stop`, {
        publicKey: address,
        vestingId: vestingId,
      });
      console.log(ret.data);
      if (ret.data.result) {
        await this.getVestingList();
      } else {
        alert(ret.data.err);
      }
    },
    async getVestingDashboard() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/vesting/dashboard`, {
        publicKey: address,
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.vestings = ret.data.vestings;
        this.isAdmin = ret.data.isAdmin == true;
        this.total.total = ret.data.total;
        this.total.locked = ret.data.locked;
        this.total.claimable = ret.data.claimable;
        this.total.claimed = ret.data.claimed;
      }
    },
    showAddress(address) {
      return (
        address.substring(0, 5) + "..." + address.substring(address.length - 3)
      );
    },
    showDate(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm:ss");
      }
      return '';
    }
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      //await this.getDragoInventory();
      await this.getVestingDashboard();
    },
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString('en-US');
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm:ss");
      }
    },
  },
  data: function () {
    return {
      newVesting: {
        poolType: 0,
        address: "",
        total: 0,
        title: "",
        started: "",
        cliff: "",
        frequency: 0,
        count: 0,
      },
      menu: 0,
      sub_menu: 0,
      modals: {
        popup_wait_claim_tx: false,
        popup_done_claim_tx: false,
        popup_admin: false,
      },
      vestings: [],
      isAdmin: false,
      total: {
        total: 0,
        locked: 0,
        claimed: 0,
        claimable: 0,
      },
      admin: {
        vestings: [],
      },
      tx_id: "",
      claimable: 0,
    };
  },
};
</script>
<style>
.page-header {
  max-height: none !important;
}

.bg_bonus-area {
  width: 100%;
  border: solid 0 #000;
  background-color: #04050d;
}

.MYREWARD {
  position: absolute;
  width: 800px;
  height: 100px;
  top: 200px;
  left: calc(50% - 400px);
  background-image: linear-gradient(to right, #523bff, #2cd9bc),
    linear-gradient(to bottom, #24f9c5, #24f9c5);
  font-size: 60px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -1.8px;
  text-align: center;
  color: #24f9c5;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.staking_tab {
  width: 200px;
  height: 100%;
  padding-top: 25px;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  display: inline-block;
  cursor: pointer;
}

.staking_tab.on {
  color: #16ffda;
}

.staking_main_tab {
  cursor: pointer;
  width: 292px;
  height: 48px;
  padding-top: 12px;
  font-family: Poppins;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #fff;
  display: inline-block;
}

.staking_main_tab.on {
  border-radius: 24px;
  box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.2);
  border: solid 0 #000;
  background-color: #06f;
}

.staking_tab_bar {
  position: absolute;
  bottom: 0px;
  width: 200px;
  height: 4px;
  border: solid 0 #000;
  background-color: #15ffd9;
}

.bg_staking_total {
  width: 1280px;
  height: 340px;
  border: solid 0 #000;
  background-color: #111529;
}

.bg_reward_main {
  width: 1280px;
  height: 942px;
  border: solid 0 #000;
  background-color: #1b1f34;
}

.bg_staking_stake {
  width: 1440px;
  height: 1434px;
  border: solid 0 #000;
  background-color: #1b1f34;
}

.bg_card_reward_bonus {
  width: 1180px;
  height: 240px;
  border-radius: 12px;
  box-shadow: 0px 10px 10px 0 rgba(0, 6, 37, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.bg_popup_admin {
  width: 1140px;
  height: 570px;
}
</style>
